import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Brand */}
          <div>
           <img 
              src="/Logo5.png" 
              alt="NorthFold Logo" 
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              Designed for Living. Crafted for Life.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/northfold.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-[#242424] flex items-center justify-center hover:border-[#B89A4F] hover:bg-[#B89A4F] transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-[#242424] flex items-center justify-center hover:border-[#B89A4F] hover:bg-[#B89A4F] transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm tracking-widest uppercase mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-[#B89A4F] transition-colors duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-sm text-gray-400 hover:text-[#B89A4F] transition-colors duration-300">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-400 hover:text-[#B89A4F] transition-colors duration-300">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-[#B89A4F] transition-colors duration-300">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-[#B89A4F] transition-colors duration-300">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm tracking-widest uppercase mb-6">Services</h4>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400">Luxury Modular Kitchens</li>
              <li className="text-sm text-gray-400">Designer Wardrobes</li>
              <li className="text-sm text-gray-400">Smart Budget Solutions</li>
              <li className="text-sm text-gray-400">Storage Solutions</li>
              <li className="text-sm text-gray-400">Entertainment Units</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm tracking-widest uppercase mb-6">Get in Touch</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#B89A4F] mt-1 flex-shrink-0" />
                <p className="text-sm text-gray-400">
                  Near Goyal Hyundai, Wadala Chownk, Nakodar Road<br />
                  Jalandhar, Punjab, India - 144003
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={18} className="text-[#B89A4F] flex-shrink-0" />
                <p className="text-sm text-gray-400">+91 7888952279</p>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} className="text-[#B89A4F] flex-shrink-0" />
                <p className="text-sm text-gray-400">Northfold7@gmail.com</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#242424] mt-12 pt-8">
          <p className="text-center text-sm text-gray-500">
            © {new Date().getFullYear()} NorthFold Kitchens & Wardrobes. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
